import { Injectable, EventEmitter } from "@angular/core";
import {
  SignalRService,
  SignalREventService,
  PoweredBy,
  PoweredBysByModel,
  ToastrService,
  DataArray,
  GlobalService,
} from "./../index";

@Injectable()
export class PoweredByService {
  public poweredByChange: EventEmitter<PoweredBy[]> = new EventEmitter<
    PoweredBy[]
  >();
  public poweredBysByModelChange: EventEmitter<PoweredBysByModel> =
    new EventEmitter<PoweredBysByModel>();

  public poweredBys: DataArray<PoweredBy> = new DataArray<PoweredBy>();

  private filterEnabled = false;

  private filteredSerial = "";
  private filterActive = true;
  private filterInactive = true;
  private filterIds: number[] = [];
  private live = true;

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _toastrService: ToastrService,
    private _GlobalService: GlobalService
  ) {
    this.registerOnServerEvents();
  }

  public setLive(flag: boolean): void {
    this.live = flag;
  }

  public getPoweredBysByModel(modelId: number): void {
    if (this.filterEnabled) {
      this._signalRService.invoke(
        "FilterPoweredBys",
        modelId,
        this.filteredSerial,
        this.filterActive,
        this.filterInactive,
        this.filterIds
      );
      return;
    }
    this._signalRService.invoke("GetPoweredBys", modelId, this.live);
  }
  public getPoweredBysByModelStaged(modelId: number): void {
    if (this.filterEnabled) {
      this._signalRService.invoke(
        "FilterPoweredBysStaged",
        modelId,
        this.filteredSerial,
        this.filterActive,
        this.filterInactive,
        this.filterIds
      );
      return;
    }

    this._signalRService.invoke("GetPoweredBysStaged", modelId);
  }

  public create(poweredByName: string): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "CreatePoweredBy",
              poweredByName,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "CreatePoweredBy",
              poweredByName,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }

  public getUseCount(poweredById: number): Promise<number> {
    return this._signalRService
      .invoke("GetPoweredByUseCount", poweredById)
      .then((result: number) => {
        return result;
      });
  }
  public getUseCountStaged(poweredById: number): Promise<number> {
    return this._signalRService
      .invoke("GetPoweredByUseCountStaged", poweredById)
      .then((result: number) => {
        return result;
      });
  }

  public getPoweredBys(): void {
    this._signalRService.invoke("GetPoweredBys");
  }
  public getPoweredBysStaged(): void {
    this._signalRService.invoke("GetPoweredBysStaged");
  }

  public setFilter(
    serial: string,
    activeEquipment: boolean,
    inActiveEquipment: boolean,
    selectedPoweredBys: number[]
  ): void {
    this.filterEnabled = true;
    this.filteredSerial = serial;
    this.filterActive = activeEquipment;
    this.filterInactive = inActiveEquipment;
    this.filterIds = selectedPoweredBys;
  }

  public clearFilter() {
    this.filterEnabled = false;
    this.filteredSerial = "";
    this.filterActive = true;
    this.filterInactive = true;
    this.filterIds = [];
  }

  private onPoweredBys(info: any): void {
    this.poweredBys.init();

    for (const item of info.Data.PoweredBys) {
      const poweredBy: PoweredBy = $.extend(new PoweredBy(), item);
      this.poweredBys.push(poweredBy);
    }

    this.poweredByChange.emit(this.poweredBys.Data);
  }

  private onPoweredBysByModel(info: any): void {
    const poweredBysByModel: PoweredBysByModel = new PoweredBysByModel();
    const poweredBysByModelList: DataArray<PoweredBy> =
      new DataArray<PoweredBy>(1);

    for (const item of info.Data.PoweredBys) {
      const minesite: PoweredBy = $.extend(new PoweredBy(), item);
      poweredBysByModelList.update(minesite, true);
    }
    poweredBysByModel.ModelId = info.Data.ModelId;
    poweredBysByModel.PoweredBys = poweredBysByModelList.Data;
    this.poweredBysByModelChange.emit(poweredBysByModel);
  }

  private onNewPoweredBy(info: any): void {
    this.poweredBys.update(
      $.extend(new PoweredBy(), info.Data.PoweredBy),
      true
    );
    this._toastrService.displayToastrMessage(
      "success",
      "Powered By " + info.Data.PoweredBy.Name + " created!",
      "Create Powered By"
    );
    this.poweredByChange.emit(this.poweredBys.Data);
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "PoweredByService",
      "poweredbys",
      (info: any) => this.onPoweredBys(info)
    );
    this._signalREventService.register(
      "PoweredByService",
      "poweredbysbymodel",
      (info: any) => this.onPoweredBysByModel(info)
    );
    this._signalREventService.register(
      "PoweredByService",
      "newPoweredBy",
      (info: any) => this.onNewPoweredBy(info)
    );
  }
  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("PoweredByService");
  }
}
